import { Dialog } from "primereact/dialog";
import { InvoiceSummaryService } from "../InvoiceSummaryService";
import { useEffect } from "react";
import { useDataTable } from "../../../../shared/hooks/DataTable";
import {
  InvoiceSummary,
  OInvoiceLookUpField,
} from "../../../../shared/constants";
import { FormattedCurrency } from "../../../../shared/component/FormattedCurrency";
import { useTranslation } from "../../../../shared/language";

export const DetailDialog = ({
  open,
  onHide,
  id,
  summaryData,
}: {
  open: boolean;
  onHide: (open: boolean) => void;
  id: string;
  summaryData?: InvoiceSummary | InvoiceSummary[];
}) => {
  const { t } = useTranslation();
  const { render: renderDataTable, refreshLazyData } = useDataTable({
    indexColumnWidth: 50,
    selectionMode: "none",
    columns: [
      {
        field: OInvoiceLookUpField.INVOICE_SERIAL,
        header: t("common.symbol"),
        sortable: false,
      },
      {
        field: OInvoiceLookUpField.INVOICE_NUMBER,
        header: t("common.invoiceNo"),
        sortable: false,
      },
      {
        field: OInvoiceLookUpField.INVOICE_DATE,
        header: t("common.invoiceCreationDate"),
        sortable: false,
      },
      {
        field: OInvoiceLookUpField.BUYER_NAME,
        header: t("common.buyerDisplayName"),
        sortable: false,
      },
      {
        field: OInvoiceLookUpField.BUYER_TAX_CODE,
        header: t("common.buyerTaxCode"),
        sortable: false,
      },
      {
        field: OInvoiceLookUpField.BUYER_BUDGET_UNIT_CODE,
        header: t("common.budgetUnitCode"),
        sortable: false,
        width: 190,
      },
      {
        field: OInvoiceLookUpField.TOTAL_AMOUNT,
        header: t("common.totalPayment"),
        sortable: false,
        dataType: "custom",
        width: 130,
        customCell: (item) => (
          <FormattedCurrency
            value={item[OInvoiceLookUpField.TOTAL_AMOUNT]}
            currency={!Array.isArray(summaryData) && summaryData.currencyCode}
          />
        ),
      },
    ],
    getList: () => {
      if (!id) {
        return Promise.resolve({
          items: [],
          totalCount: 0,
        });
      }
      return InvoiceSummaryService.getInvoiceSummaryById(id).then((data) => ({
        items: data,
        totalCount: data.length,
      }));
    },
  });

  useEffect(() => {
    if (id) {
      refreshLazyData();
    }
    // add refreshLazyData to deps cause infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <Dialog
      header={t("report.summaryDetails")}
      visible={open}
      style={{ width: "100%", maxWidth: "1000px" }}
      onHide={() => onHide(false)}
    >
      {renderDataTable()}
    </Dialog>
  );
};
